import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonWidgetComponent } from './common-widget/common-widget.component';
import { IntersectionObserverDirective } from '../directives/intersection-observer.directive';
import { TimesPipe } from '../pipe/TimesPipe';
import { CommonSkeletonComponent } from '../skeleton/common-skeleton/common-skeleton.component';

/**
 * Widget Module for Dynamic Component Loading
 *
 * ARCHITECTURE NOTE:
 * This module uses Angular's built-in NgComponentOutlet for dynamic component loading,
 * replacing the previous ng-dynamic-component library dependency.
 *
 * HYBRID ARCHITECTURE:
 * - Main app uses modern standalone components (bootstrapApplication)
 * - This module provides the CommonWidgetComponent for widget rendering
 * - All widget components remain standalone and are loaded dynamically via NgComponentOutlet
 * - Widget inputs are passed via custom Injector using WIDGET_DATA token
 * - This module is imported in app.config.ts via importProvidersFrom()
 */
@NgModule({
  declarations: [
    // ONLY CommonWidgetComponent - the dynamic widget container
    CommonWidgetComponent
  ],
  imports: [
    CommonModule,

    // Standalone dependencies used by CommonWidgetComponent
    IntersectionObserverDirective,
    TimesPipe,
    CommonSkeletonComponent
  ],
  exports: [
    CommonWidgetComponent // Export for use in other components
  ]
})
export class WidgetModule { }
